const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "\\u0428\\u0430\\u0440 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.75,
    height: 58.75,
    viewBox: "0 0 54.75 58.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "lift"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -0.75,
    y: 38.63,
    width: 12.87,
    height: 3.46,
    rx: 1.73,
    ry: 1.73,
    transform: "translate(36.95 14.22) rotate(58.12)",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeMiterlimit: 10,
      strokeWidth: "1.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.9,57.85h40.51c.99,0,1.95-.38,2.72-1.07.61-.54,1.03-1.29,1.31-2.09l.46-1.34",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.62,
    y1: 36.67,
    x2: 7.4,
    y2: 38.85,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.9,
    y1: 7.35,
    x2: 16.08,
    y2: 32.97,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.7px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.4,
    cy: 5.85,
    r: 5,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.33,
    y1: 17.27,
    x2: 34.05,
    y2: 20.8,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.69,
    y1: 14.6,
    x2: 36.9,
    y2: 18.69,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.78,14.37c.25-1.56-.82-3.03-2.38-3.28l-1.25-.2c-1.56-.25-3.03.82-3.28,2.38l-2.95,18.7c-.02,2.37,1.13,3.49,1.31,3.86l9.69,20.19c.58,1.21,2.03,1.71,3.23,1.14s1.71-2.03,1.14-3.23l-9.26-19.29c.41-.41.71-.95.81-1.57l2.49-15.76",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeMiterlimit: 10,
      strokeWidth: "1.7px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLift);
export default __webpack_public_path__ + "static/media/lift.d3f3cc3b2477c6d79011189534617c62.svg";
export { ForwardRef as ReactComponent };